var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../styles/main.css";
import "../styles/login.css";
/**
* The Login Template
* This template is entitled to all the authentication for providing its structure.
* The props accepted are image for the left side and form element for the right side of the page.
* @param props
* @returns
*/
function LoginTemplate(props) {
    return (_jsxs("div", __assign({ className: "min-h-screen flex flex-col md:flex-row w-full" }, { children: [_jsx("div", __assign({ className: "hidden md:flex md:w-1/2 items-center justify-center bg-gray-50" }, { children: _jsx("div", __assign({ className: "w-full h-screen md:h-full flex items-center justify-center overflow-hidden" }, { children: props.leftImage })) })), _jsx("div", __assign({ className: "w-full md:w-1/2 flex items-center justify-center px-4 py-8 md:py-0" }, { children: _jsx("div", __assign({ className: "w-full max-w-sm" }, { children: props.form })) }))] })));
}
export default LoginTemplate;
